import { readonly, ref } from 'vue';

const queryStore = ref(new Map());

export function useQueryStore() {
  const setStoreQuery = (routeName, query) => {
    queryStore.value.set(routeName, { ...query });
  };

  const getStoreQuery = (routeName) => {
    return queryStore.value.get(routeName) || {};
  };

  const clearStoreQuery = (routeName) => {
    queryStore.value.delete(routeName);
  };

  const clearAll = () => {
    queryStore.value.clear();
  };

  return {
    clearAll,
    clearStoreQuery,
    getStoreQuery,
    queryStore: readonly(queryStore),
    setStoreQuery,
  };
}
